<div class="nav-menu dark">
  <ul class="navbar-nav">
    @if (customerConfigService.isAlarmsEnabled()) {
      <li class="nav-item">
        <div class="menu">
          <a class="nav-link" href="#"
            [routerLink]="['office-hour-management']"
            routerLinkActive
            #businessHourManagementLink="routerLinkActive"
            [ngClass]='{"selected": businessHourManagementLink.isActive}'>
            <span translate="menu.navigation.infrastructure.businessHourManagement"></span>
          </a>
        </div>
      </li>
    }
    @if (customerConfigService.isInfrastructureEnabled()) {
      <li class="nav-item">
        <div class="menu">
          <a class="nav-link" href="#"
            [routerLink]="['maintenance']"
            routerLinkActive
            #maintenanceLink="routerLinkActive"
            [ngClass]='{"selected": maintenanceLink.isActive}'>
            <span translate="menu.navigation.infrastructure.maintenance"></span>
          </a>
        </div>
      </li>
    }
    @if (customerConfigService.isInfrastructureEnabled()) {
      <li class="nav-item">
        <div class="menu">
          <a class="nav-link" href="#"
            [routerLink]="['interventions']"
            routerLinkActive
            #interventionsLink="routerLinkActive"
            [ngClass]='{"selected": interventionsLink.isActive}'>
            <span translate="menu.navigation.infrastructure.interventions"></span>
          </a>
        </div>
      </li>
    }
  </ul>
</div>

<router-outlet></router-outlet>

